export default "__VITE_ASSET__C0J9qo0B__"